<template>
  <div id="sendOTP" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="sendOTP"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content stella-modal stella-auth-modal">
        <div class="modal-body p-2 m-2">

          <img class="img-fluid float-end d-block zoom-12" data-dismiss="modal" src="@/assets/images/stella/close.png">

          <div class="my-5 py-4 text-center d-md-none d-block" >
            <img class="img-fluid hero-img" src="@/assets/images/stella/reset-password.png">
          </div>



          <div class="text-white font-size-24 font-family-poppins mt-4">Forgot Password?</div>

          <div class="text-grey font-size-16 mt-4">Don't worry! Please enter your email associated with your account.
          </div>

          <div class="py-3 w-100 invisible"></div>



          <div class="form-group mt-3">
            <label class="mb-2 font-dark-grey font-size-16">Your Email</label>
              <span class="danger ml-2" v-if="isRequired('email')">This is required field</span>
              <span class="danger ml-2" v-if="isValidEmail()">Not a valid email address</span>
            </label>
            <div class="input-group flex-nowrap stella-group">
            <input id="email" type="email"
                   autocomplete="false"
                   placeholder="example@mail.com"
                   class="form-control stella-input"
                   name="email"
                   v-model="changePassword.email">
            </div>
          </div>

          <div class="py-3 w-100 invisible"></div>

          <div class="d-flex justify-content-center py-2">
            <button type="button"
                    class="btn stella-btn gradient-a w-100 rounded-pill"
                    @click="sendOTP()">Send OTP
            </button>
          </div>

          <div class="py-3 w-100 invisible"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SERVICE_IDENTIY} from "@/properties/micro-service";
import {forgotPasswordMixin} from "@/mixin/forgot-password-mixin";
import ModelGlobalMessage from "@/components/module/shared/ModelGlobalMessage";
import {required, email} from "vuelidate/lib/validators";

export default {
  name: "ForgotPasswordSendOTP",
  mixins: [forgotPasswordMixin],
  components: {ModelGlobalMessage},
  date() {
    return {}
  },
  validations: {
    changePassword: {
      email: {required, email},
    }
  },
  /*
   changePassword: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        otp: null,
        email: null
      }
  * */

  methods: {
    show() {
      $('#sendOTP').modal();
      this.changePassword = {};
    },
    hide() {
      $('#sendOTP').modal('hide');
    },

      isValidEmail() {
      return this.isLoading && !this.$v.changePassword.email.email;
    },


    sendOTP() {

      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let url = `${SERVICE_IDENTIY}/api/v1/password/otp/send`;
      this.postUnsecuredData(url, this.changePassword, (data) => {
        this.hide();
        this.$emit("otpSent", this.changePassword);
      });

    }
  }
}
</script>

<style scoped>
.stella-modal {
  background: rgba(20, 20, 20, 0.85) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 20px !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
}

.input-transparent {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 15px !important;
  font-size: 15px;
  transition: all 0.3s ease;
}

.input-transparent:focus {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(197, 111, 209, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
  outline: none;
}

.input-transparent::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* Chrome autofill override */
.input-transparent:-webkit-autofill,
.input-transparent:-webkit-autofill:hover, 
.input-transparent:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset !important;
    box-shadow: 0 0 0 1000px #1e1e1e inset !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

.input-transparent:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset, 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
    box-shadow: 0 0 0 1000px #1e1e1e inset, 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
    border-color: rgba(197, 111, 209, 0.5) !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    outline: none !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

/* Close icon hover effect */
.zoom-12 {
  transition: transform 0.2s ease;
  cursor: pointer;
  opacity: 0.7;
}
.zoom-12:hover {
  transform: scale(1.2);
  opacity: 1;
}
</style>
